import styled from "styled-components";

import type { SelectOption } from "@similarweb/pro-logic-components/dist/filter-factory/src/compound";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import { getFaviconUrl } from "app/services/sitesService/sitesUtils";

export const UNKNOWN_PUBLISHER_SENTINEL = "Unknown publisher";

const FaviconIcon = styled.img`
    width: 16px;
    height: 16px;
    border-radius: 2px;
`;

export const renderFaviconItem = (item: SelectOption) =>
    item.value === UNKNOWN_PUBLISHER_SENTINEL ? (
        <>{item.label}</>
    ) : (
        <Flex
            alignItems="center"
            gap="8px"
        >
            <FaviconIcon
                src={getFaviconUrl(item.value)}
                alt=""
            />
            {item.label}
        </Flex>
    );

export const toEntityOptions = (values: string[], selected: string[], hasSearchTerm: boolean): SelectOption[] => {
    const merged = hasSearchTerm ? values : [...values, ...selected.filter((value) => !values.includes(value))];
    const options: SelectOption[] = [];
    let sentinelOption: SelectOption | undefined;

    for (const value of merged) {
        const option = { id: value, value, label: value };
        if (value === UNKNOWN_PUBLISHER_SENTINEL) {
            sentinelOption = option;
        } else {
            options.push(option);
        }
    }

    return sentinelOption ? [...options, sentinelOption] : options;
};

const FilterEmptyState = ({ children }: { children: string }) => (
    <Text
        display="inline-block"
        fontVariant="chip1"
        marginX="16px"
        paddingY="16px"
    >
        {children}
    </Text>
);

// A string emptyState is frozen by a memo cache inside the library's empty-state
// renderer, so it keeps the first text forever; a ReactNode bypasses that cache.
export const createFilterEmptyState =
    (loadingText: string, noResultsText: string) => (isPending: boolean, options: SelectOption[]) =>
        (
            <FilterEmptyState>{isPending && !options.length ? loadingText : noResultsText}</FilterEmptyState>
        ) as unknown as string;
